import {
  type JobAnalysisResponse,
  type WebCallConnectionResponse,
} from "../api";
import { Utility } from "./utility";

export interface JobAnalysis extends JobAnalysisResponse {}

export class JobAnalysis extends Utility<JobAnalysis> {
  constructor(init?: Partial<JobAnalysisResponse>) {
    super();
    Object.assign(this, init);
  }
}

export interface JobAnalysisWebCall extends WebCallConnectionResponse {}

export class JobAnalysisWebCall extends Utility<JobAnalysisWebCall> {
  constructor(init?: Partial<WebCallConnectionResponse>) {
    super();
    Object.assign(this, init);
  }
}
